function init() {

  // Shortcode - Course Video Player
  if ($("#ghdVideoPlayer").length > 0) {
    // console.log('ghdVideoPlayer');

    $("#ghdVideoPlayer").each(function() {
      var ghdVideoPlayer = $(this);
      // console.log('cur_ghdVideoPlayer');
      
      setTimeout(function() {
        ghdVideoPlayer.removeClass('loading').addClass("ready");
      }, 1000);

      if ( ghdVideoPlayer.attr('attr-video-type') === 'course' ) {

        // Vimeo events listener
        if ( ghdVideoPlayer.attr('attr-video-src') === 'vimeo' ) {
            var player = new Vimeo.Player('vimeo_embed');

            player.on("play", function() {
              // console.log("video PLAY");
              ghdVideoPlayer.removeClass('active-cover');
            });
            player.on("ended", function() {
              // console.log("video END");
              ghdVideoPlayer.addClass('active-cover');
            });

            ghdVideoPlayer.find('a.replay').on('click', function(e) {
              player.play();
              e.preventDefault();
            });
            
        } 

        // Wistia events listener
        else if ( ghdVideoPlayer.attr('attr-video-src') === 'wistia' ) {
            window._wq = window._wq || [];
            _wq.push({ id: "_all", onReady: function(player) {
              player.bind("play", function() {
                  // console.log("video PLAY");
                  ghdVideoPlayer.removeClass('active-cover');
              });
              player.bind("end", function() {
                  // console.log("video END");
                  ghdVideoPlayer.addClass('active-cover');
              });

              ghdVideoPlayer.find('a.replay').on('click', function(e) {
                  player.play();
                  e.preventDefault();
              });

            }});

        }
        
      }

    });
  }

}

module.exports = { init };